// removed by extract-text-webpack-plugin
module.exports = {"activity":"_2EFVkIo9j1iBL32PR3WgNT_0","callInfo":"_3HBefI2RmGhLSoIzd3Tybk_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d1d5e770","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/OngoingMeetings.vue
// module id = dJix
// module chunks = 1